import http from '@/http'
import tokenValidate from '@/services/tokenValidate'
import { toISO8601 } from '@/utils'
export default {
  namespaced: true,
  state: {
    token: '',
    forgotPasswordEmail: '',
    hashSixDigits: '',
    userId: '',
    newUserId: '',
    showFullScreen: false,
    isLogin: false,
    isLogged: false,
    tokenIssuedAt: null
  },
  mutations: {
    setToken(state, token) {
      localStorage.setItem('@token_staage', token)
      state.token = token
    },
    setUserId(state, userId) {
      state.userId = userId
    },
    logout(state) {
      state.token = ''
      localStorage.removeItem('@token_staage')
    },
    setForgotPasswordEmail(state, email) {
      state.forgotPasswordEmail = email
    },
    setHashSixDigits(state, hashSixDigits) {
      state.hashSixDigits = hashSixDigits
    },
    setNewUserId(state, newUserId) {
      state.newUserId = newUserId
    },
    setShowFullScreen(state, showFullScreen) {
      state.showFullScreen = showFullScreen
    },
    setIsLogin(state, isLogin) {
      state.isLogin = isLogin
    },
    setIsLogged(state, isLogged) {
      state.isLogged = isLogged
    },
    setTokenIssuedAt(state, tokenIssuedAt) {
      state.tokenIssuedAt = tokenIssuedAt
    }
  },
  actions: {
    async doLogin({ commit }, user) {
      try {
        const response = await http.post('/user/login', user)
        if (response.data.status === true) {
          const token = response.data.data.token
          const { userId, iat } = tokenValidate.decodeToken(token)
          commit('setToken', token)
          commit('setTokenIssuedAt', new Date(iat * 1000).getDate())
          commit('setUserId', userId)
        }
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    async doLogout({ commit }) {
      try {
        commit('logout')
        window.location.reload()
      } catch (err) {
        console.error(err)
      }
    },
    async register({ commit }, user) {
      try {
        user['birthdate'] ? (user['birthdate'] = toISO8601(user.birthdate)) : ''
        const response = await http.post('user/register', user)
        if (response.data.status === true) {
          commit('setNewUserId', response.data.data.user.userID)
        }
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    async forgotSendToken({ commit }, sendInfo) {
      try {
        const response = await http.post('/user/forgot/sendToken', sendInfo)
        if (response.data.status) {
          const email = response.data.forgotData.target
          commit('setForgotPasswordEmail', email)
        }
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    async forgotValidationCode({ commit }, validationInfo) {
      try {
        const response = await http.post('/user/forgot/validationCode', validationInfo)
        if (response.data.status) {
          const hashSixDigits = response.data.hashSixDigits
          commit('setHashSixDigits', hashSixDigits)
        }
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    async forgotChangePassword({ commit }, changePasswordInfo) {
      try {
        const response = await http.post('/user/forgot/changePassword', changePasswordInfo)
        if (response.data.status) {
          commit('setForgotPasswordEmail', '')
          commit('setHashSixDigits', '')
        }
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    async softLoginConfigure({}, configureCode) {
      try {
        const response = await http.post('/user/softLoginConfigure', { code: configureCode })
        if (!response.data.status) {
          return false
        }
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    async getToken({ state }) {
      try {
        return localStorage.getItem('@token_staage') || state.token
      } catch (err) {
        console.error(err)
      }
    },
    async isLogged({ dispatch, state, commit }) {
      try {
        const token = await dispatch('getToken')
        if (!token) {
          commit('setIsLogged', false)
          return false
        }
        const userLoggedId = state.userId
        const isValidToken = await tokenValidate.verifyToken(token, userLoggedId)
        if (!isValidToken) {
          commit('setIsLogged', false)
          return false
        }
        commit('setIsLogged', true)
        return true
      } catch (err) {
        console.error(err)
      }
    },
    async refreshToken({ commit }) {
      try {
        const response = await http.post('user/token/refresh')
        const { iat } = tokenValidate.decodeToken(response.data.data.newToken)
        commit('setToken', response.data.data.newToken)
        commit('setTokenIssuedAt', new Date(iat * 1000).getDate())
      } catch (err) {
        console.error(err)
      }
    },
    islogin({ commit }, isLogin) {
      try {
        commit('setIsLogin', isLogin)
      } catch (err) {
        console.error(err)
      }
    }
  },
  getters: {
    forgotPasswordEmail: state => state.forgotPasswordEmail,
    hashSixDigits: state => state.hashSixDigits,
    userFollow: state => state.user.userFollow,
    showFullScreen: state => state.showFullScreen,
    isLogin: state => state.isLogin,
    getIsLogged: state => state.isLogged,
    getTokenIssuedAt: state => state.tokenIssuedAt
  }
}
